import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeGrid2Editor = () => {
  const [form, setForm] = useState({
    topRightTitleEn: "",
    topRightTitleAr: "",
    topRightTitleKu: "",

    topRightDescEn: "",
    topRightDescAr: "",
    topRightDescKu: "",

    bottomLeftTitleEn: "",
    bottomLeftTitleAr: "",
    bottomLeftTitleKu: "",

    bottomLeftDescEn: "",
    bottomLeftDescAr: "",
    bottomLeftDescKu: "",
  });

  const [images, setImages] = useState({
    topLeftImg: null,
    bottomRightImg: null,
  });

  const [loading, setLoading] = useState(true);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // ======================================
  // LOAD TEXT + IMAGES IN ALL 3 LANGUAGES
  // ======================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFGrid2Section?lang=en`),
          axios.get(`${API_BASE}/api/VFGrid2Section?lang=ar`),
          axios.get(`${API_BASE}/api/VFGrid2Section?lang=ku`),
        ]);

        setForm({
          topRightTitleEn: en.data.topRightTitle,
          topRightDescEn: en.data.topRightDesc,
          bottomLeftTitleEn: en.data.bottomLeftTitle,
          bottomLeftDescEn: en.data.bottomLeftDesc,

          topRightTitleAr: ar.data.topRightTitle,
          topRightDescAr: ar.data.topRightDesc,
          bottomLeftTitleAr: ar.data.bottomLeftTitle,
          bottomLeftDescAr: ar.data.bottomLeftDesc,

          topRightTitleKu: ku.data.topRightTitle,
          topRightDescKu: ku.data.topRightDesc,
          bottomLeftTitleKu: ku.data.bottomLeftTitle,
          bottomLeftDescKu: ku.data.bottomLeftDesc,
        });

        setImages({
          topLeftImg: en.data.topLeftImg,
          bottomRightImg: en.data.bottomRightImg,
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed to load VFGrid2:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ======================================
  // SAVE TEXT
  // ======================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFGrid2Section/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to update.");
    }
  };

  // ======================================
  // UPLOAD IMAGE
  // ======================================
  const handleUploadImage = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();

    if (uploadTarget === "topLeft") fd.append("TopLeftImage", uploadFile);
    if (uploadTarget === "bottomRight") fd.append("BottomRightImage", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VFGrid2Section/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE – Grid 2 Section Editor</h2>

      {/* ======================================
          TEXT FIELDS (Top Right + Bottom Left)
      ======================================= */}
      <h4 className="fw-bold mt-4">Top Right Text</h4>
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 col-md-6 mb-4" key={`TR-${l}`}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{l} Version</h5>

                <label className="form-label mt-2">Title</label>
                <input
                  className="form-control mb-2"
                  name={`topRightTitle${l}`}
                  value={form[`topRightTitle${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  name={`topRightDesc${l}`}
                  value={form[`topRightDesc${l}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <h4 className="fw-bold mt-5">Bottom Left Text</h4>
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 col-md-6 mb-4" key={`BL-${l}`}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{l} Version</h5>

                <label className="form-label mt-2">Title</label>
                <input
                  className="form-control mb-2"
                  name={`bottomLeftTitle${l}`}
                  value={form[`bottomLeftTitle${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  name={`bottomLeftDesc${l}`}
                  value={form[`bottomLeftDesc${l}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ======================================
          IMAGE PREVIEWS
      ======================================= */}
      <h4 className="fw-bold mb-3">Images</h4>

      {[
        { key: "topLeft", label: "Top Left Image" },
        { key: "bottomRight", label: "Bottom Right Image" },
      ].map((img) => (
        <div className="card shadow-sm border-0 mb-4" key={img.key}>
          <div className="card-body">
            <h5 className="mb-3">{img.label}</h5>

            {images[`${img.key}Img`] ? (
              <img
                src={resolveUrl(images[`${img.key}Img`])}
                alt=""
                className="w-100 rounded mb-3"
                style={{ maxHeight: "260px", objectFit: "cover" }}
              />
            ) : (
              <p>No image uploaded.</p>
            )}

            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadFile(null);
                setUploadTarget(img.key);
                setShowModal(true);
              }}
            >
              Upload / Replace
            </button>
          </div>
        </div>
      ))}

      {/* ======================================
          MODAL
      ======================================= */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Upload {uploadTarget} Image
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleUploadImage}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahFreeGrid2Editor;
